import React from "react";
import { Link } from "react-router-dom";

const LaserEngraving = () => {
  return (
    <div className="p-8 bg-gray-100 rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-center text-gray-900 mb-4">
        Laser Engraving Services
      </h1>
      <p className="text-lg text-gray-700 mb-6">
        Enhance your knives with custom laser engravings! Personalize your blades with names, logos, or intricate designs. Our high-precision laser engraving service ensures a clean and professional finish.
      </p>
      <div className="mb-6">
        <img
          src="https://via.placeholder.com/600x300" // Replace this with your image path
          alt="Laser Engraving"
          className="w-full h-auto rounded-lg shadow-md"
        />
      </div>
      <button
        className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        onClick={() => alert("Contact us to learn more!")}
      >
        Contact Us
      </button>
      {/* Link to laser engraving service page */}
      <Link
        to="/laser-engraving"
        className="block mt-4 text-center text-blue-600 hover:text-blue-700"
      >
        Learn More
      </Link>
    </div>
  );
};

export default LaserEngraving;